import { useMutation } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import useAxiosInstance from "./utils/axiosIntance";

type JoinGamePayload = {
  gameId: string;
  playerName: string;
};

type JoinGameResponse = {
  isSuccess: boolean;
  gameId: string;
  id: string;
  name: string;
  isAdmin: boolean;
  isOnline: boolean;
  isReady: boolean;
};

const useJoinGame = () => {
  const axios = useAxiosInstance();
  const { mutate: joinGame } = useMutation<
    AxiosResponse<JoinGameResponse>,
    AxiosError,
    JoinGamePayload
  >({
    mutationFn: (payload: JoinGamePayload) => {
      return axios.put("/game/join", payload, {
        withCredentials: true,
      });
    },
  });
  return joinGame;
};

export default useJoinGame;
